"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMithrilStateComponent = exports.IMithrilComponent = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var mithril_1 = require("../mithril");
var IMithrilComponent = /** @class */ (function () {
    function IMithrilComponent(key) {
        this.lifeCycleParams = {};
        if (key != null) {
            this.lifeCycleParams.key = key;
        }
        if (this.onCreate) {
            this.lifeCycleParams.oncreate = this.onCreate.bind(this);
        }
        if (this.onUpdate) {
            this.lifeCycleParams.onupdate = this.onUpdate.bind(this);
        }
        if (this.onRemove) {
            this.lifeCycleParams.onremove = this.onRemove.bind(this);
        }
    }
    IMithrilComponent.prototype.view = function () {
        var nodes = this.nodes;
        if (Array.isArray(nodes)) {
            return mithril_1.m.fragment(this.lifeCycleParams, nodes);
        }
        return mithril_1.m.fragment(this.lifeCycleParams, [nodes]);
    };
    return IMithrilComponent;
}());
exports.IMithrilComponent = IMithrilComponent;
var IMithrilStateComponent = /** @class */ (function (_super) {
    tslib_1.__extends(IMithrilStateComponent, _super);
    function IMithrilStateComponent() {
        var _this = _super.call(this) || this;
        _this.reactions = [];
        return _this;
    }
    IMithrilStateComponent.prototype.autorun = function (view) {
        this.reactions.push((0, mobx_1.autorun)(view));
    };
    IMithrilStateComponent.prototype.reaction = function (expression, effect, opts) {
        this.reactions.push((0, mobx_1.reaction)(expression, effect, opts));
    };
    IMithrilStateComponent.prototype.onRemove = function () {
        this.reactions.forEach(function (r) { return r(); });
    };
    return IMithrilStateComponent;
}(IMithrilComponent));
exports.IMithrilStateComponent = IMithrilStateComponent;
//# sourceMappingURL=mithril.component.js.map